export default class DistanceViewModel {
    value: number;
    text: string;
    public constructor(value: number, text: string) {
        this.value = value;
        this.text = text;
    }
}